import axios from "axios";
import { queryParams } from "../../utils/queryParams";

const checkIns = axios.create({
  baseURL: queryParams.apiVersion + "pages/attendance/checkins_chart"
});

export const checkInsApi = {
  getFilters(params) {
    return checkIns.get("/get_filters", params);
  },
  getHeatmap(params) {
    return checkIns.post("/heatmap", params);
  },
  getBreakdown(params) {
    return checkIns.post("/breakdown", params);
  },
  getModalData(params) {
    return checkIns.post("/modal_data", params);
  },
  getDataPoints(params) {
    return checkIns.post("/data_points", params);
  }
};
